var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { Button, DropdownMenu, Link, LoadingSpinner, Text } from '@paypalcorp/pp-react';
import { getProp } from '../common/utils';
import { OTP_CODE, GENERIC_ERROR } from '../common/views';
export default ({ challenges = [], email, logger, csrf, sessionID, authEventHandler, isPomaUser = false, localizedContent, sendOtpChallenge, setView, updateAfterOtpSent, }) => {
    const [showSpinner, setShowSpinner] = useState(false);
    const [selectedChallengeId, setSelectedChallengeId] = useState(challenges[0] && challenges[0].challengeId);
    const [selectedMaskedPhoneNumber, setSelectedMaskedPhoneNumber] = useState(challenges[0] && challenges[0].maskedPhoneNumber);
    useEffect(() => {
        logger.track('send_otp_rendered');
        logger.flush({ csrf, sessionID });
        authEventHandler({
            event: 'getACodePageRendered',
        });
    }, []);
    const getPhoneOptions = () => {
        if (challenges.length > 1) {
            return (React.createElement(DropdownMenu, { options: challenges.map(({ maskedPhoneNumber, challengeId }, idx) => ({
                    primaryText: maskedPhoneNumber,
                    value: challengeId,
                    'data-testid': `option-${idx}`,
                })), value: selectedChallengeId, onChange: (e) => {
                    setSelectedChallengeId(e.target.value);
                    setSelectedMaskedPhoneNumber(challenges[e.target.selectedIndex].maskedPhoneNumber);
                    authEventHandler({
                        event: 'userChangedNumber',
                    });
                }, label: localizedContent('selectAPhone'), "data-testid": "dropdown-menu" }));
        }
        else {
            return React.createElement("p", { style: { margin: '15px 0' } },
                "Mobile ",
                challenges[0] && challenges[0].maskedPhoneNumber);
        }
    };
    const handleSendOtpClicked = () => __awaiter(void 0, void 0, void 0, function* () {
        const startTime = Date.now();
        setShowSpinner(true);
        authEventHandler({
            event: 'getACodeButtonClicked',
        });
        logger.track('send_otp_started');
        authEventHandler({ event: 'getOtpCodeClicked' });
        const response = yield sendOtpChallenge({ selectedChallengeId, selectedMaskedPhoneNumber });
        const nonce = getProp(response, 'data.otp.sendOtpNotification.nonce', '');
        if (nonce) {
            logger.track('send_otp_succeeded');
            updateAfterOtpSent({ response, selectedChallengeId, selectedMaskedPhoneNumber });
            setView(OTP_CODE);
        }
        else {
            logger.track('send_otp_failed');
            setView(GENERIC_ERROR);
        }
        logger.track(`cpl_send_otp|${JSON.stringify({ start: startTime, tt: Date.now() - startTime })}`);
    });
    return (React.createElement("div", { "data-testid": "view-send-code", className: "fade-in", style: { textAlign: 'center' } },
        React.createElement(Text, { size: "xl", style: { fontWeight: 'bold', fontSize: '1.25rem', margin: '15px 0 24px 0px', color: '#222222' } }, localizedContent('sendOtpHeading')),
        getPhoneOptions(),
        showSpinner ? (React.createElement(LoadingSpinner, { style: { margin: '30px auto' }, screenReaderText: localizedContent('loading') })) : (React.createElement(Button, { "data-testid": "button-get-login-code", theme: "v1", onClick: handleSendOtpClicked, style: { width: '100%', margin: '24px 0' } }, localizedContent('getACode'))),
        React.createElement(Link, { style: { cursor: 'pointer' }, "data-testid": "link-use-password", onClick: () => {
                logger.track('send_otp_opted_out');
                authEventHandler({
                    event: isPomaUser ? 'isPomaUser' : 'userWantsPassword',
                    data: { email },
                });
            } }, isPomaUser ? localizedContent('setupPassword') : localizedContent('loginWithPasswordInstead')),
        React.createElement(Text, { size: "sm", style: { fontSize: '13px', margin: '13px 0' } }, localizedContent('consent'))));
};
